import { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { getColor } from 'basic-components';

const MessageContainer = ({ errorMessage = undefined, successMessage = undefined, warningMessage = undefined }) => {
  const getMessageType = useCallback(() => {
    if(errorMessage) {
      return { message: errorMessage, color: getColor("red-light") }
    } else if(warningMessage && !errorMessage) {
      return { message: warningMessage, color: getColor("orange-light") }
    } else if(successMessage && !warningMessage && !errorMessage) {
      return { message: successMessage, color: getColor("green-light") }
    } else {
      return { message: " ", color: getColor("orange-light") }
    }
  }, [errorMessage, successMessage, warningMessage])
  const activeMessage = useMemo(() => getMessageType(), [getMessageType])
  return (
    <div className="ncsv-creator__top__step__row ncsv-creator__top__step__row--label">
      <div 
          className="ncsv-creator__top__step__row__label__message"
          style={{ color: activeMessage?.color }}
      >
        {activeMessage?.message}
      </div>
    </div>
  )
}

MessageContainer.propTypes = {
  errorMessage: PropTypes.string,
  successMessage: PropTypes.string,
  warningMessage: PropTypes.string
}

export default memo(MessageContainer)